import React, { useEffect, useState, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Modal,
  Box,
  TextField,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Popover,
  Typography,
  Checkbox,
  Autocomplete,
  Menu,
} from "@mui/material";
import {
  Edit,
  Delete,
  Print,
  Visibility,
  Add,
  Close,
  AttachFile,
} from "@mui/icons-material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"; // ⭐ ADD
import { Tooltip } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import "react-toastify/dist/ReactToastify.css";
import { Chip } from "@mui/material";
import dayjs from "dayjs";

import {
  GeneralVoucherList,
  DivisionList,
  ApproveSolistapi,
  GeneralVoucherCreate,
  GeneralVoucherUpdate,
  GeneralVoucherDelete,
  ApproveGeneralVoucher,
  GetNextGeneralNo,
  ExpenseList,
  ImprestMasterList,
} from "../../../Services/Services";

import { useMediaQuery, useTheme, Collapse, Divider } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
// import GeneralVoucherForm from "./GeneralVoucherForm";
import { generatePdf } from "../../components/Accounts/GeneralVoucherPrint";
import config from "../../../config";
import InfiniteScroll from "react-infinite-scroll-component";

const GeneralVoucher = () => {
  // ========== State Definitions ==========
  // ⭐ DATE RANGE STATES
  const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
  const [selectingDate, setSelectingDate] = useState(null);
  const [dateRangeFilter, setDateRangeFilter] = useState("today");
  const [customDateRange, setCustomDateRange] = useState({ from: "", to: "" });
  const dateInputRef = useRef(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [generalVouchers, setGeneralVouchers] = useState([]); // Main list of vouchers from API
  const [rows, setRows] = useState([]); // Editable table rows
  const [divisionLists, setDivisionLists] = useState([]); // Dropdown list for division
  const [projectLists, setProjectLists] = useState([]); // Dropdown list for project
  const [editFormData, setEditFormData] = useState({}); // Prefilled form data for edit
  const [expenseLists, setExpenseLists] = useState([]);
  const [imprestLists, setImprestLists] = useState([]);
  const [open, setOpen] = useState(false); // Add modal
  const [openEditModal, setOpenEditModal] = useState(false); // Edit modal
  const [editIndex, setEditIndex] = useState(null); // Index of voucher being edited
  const [deleteAnchorEl, setDeleteAnchorEl] = useState(null);
  const [selectedVoucherId, setSelectedVoucherId] = useState(null);
  const [approveAnchorEl, setApproveAnchorEl] = useState(null);
  const [GeneralToApprove, setGeneralToApprove] = useState([]);
  const [general, setgeneral] = useState([]);
  const [statusFilter, setStatusFilter] = useState("Pending");

  const [voucherSearch, setVoucherSearch] = useState("");
  const [billNoSearch, setBillNoSearch] = useState("");
  const [ledgerSearch, setLedgerSearch] = useState("");
  const [remarkInput, setRemarkInput] = useState("");
  const [showRemarkForGeneralId, setShowRemarkForGeneralId] = useState(null);
  const [actionType, setActionType] = useState(null);
  const status = ["Paid", "Unpaid"]; // Status dropdown options
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedVoucher, setExpandedVoucher] = useState(null);

  const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
  const [tempCustomDateRange, setTempCustomDateRange] = useState({
    from: "",
    to: "",
  });
  // ✅ Apply / Cancel helpers
  const handleApplyCustomDateRange = () => {
    if (tempCustomDateRange.from && tempCustomDateRange.to) {
      setCustomDateRange({ ...tempCustomDateRange });
      setDateRangeFilter("custom");
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    } else {
      toast.warning("Please select both From and To dates");
    }
  };

  const handleCancelCustomDateRange = () => {
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
  };
  // ========== Fetch initial data ==========
  useEffect(() => {
    const fetchData = async () => {
      const divisions = await DivisionList();
      const projects = await ApproveSolistapi();
      const expenses = await ExpenseList();
      const imprest = await ImprestMasterList();

      setDivisionLists(divisions);
      setProjectLists(projects);
      setExpenseLists(expenses);
      setImprestLists(imprest);
    };

    fetchData();
  }, []);
  // ✅ Debounce search
  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      fetchGeneralVouchers(1, true);
    }, 1000);

    return () => clearTimeout(handler);
  }, [
    voucherSearch,
    billNoSearch,
    statusFilter,
    ledgerSearch,
    dateRangeFilter,
    customDateRange,
  ]);

  const fetchGeneralVouchers = async (pageNum = 1, reset = false) => {
    try {
      const data = await GeneralVoucherList(pageNum, {
        voucherSearch,
        billNoSearch,
        statusFilter,
        ledgerSearch,
        date_range: dateRangeFilter, // ⭐ ADD
        from_date: customDateRange.from, // ⭐ ADD
        to_date: customDateRange.to, // ⭐ ADD
      });
      if (reset || pageNum === 1) {
        setGeneralVouchers(
          Array.isArray(data) ? data.results : data.results || []
        );
      } else {
        setGeneralVouchers((prev) => [
          ...prev,
          ...(Array.isArray(data) ? data.results : data.results || []),
        ]);
      }
      setHasMore(Array.isArray(data) ? data.next !== null : data.next !== null);
      setPage(pageNum);
    } catch (error) {
      toast.error("Failed to load vouchers");
    } finally {
      setLoading(false);
    }
  };



  const fetchMoreData = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchGeneralVouchers(nextPage);
  };

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  const costTypeOptions = [
    { value: "processing cost", label: "Processing Cost" },
    { value: "admin cost", label: "Admin Cost" },
    { value: "finance cost", label: "Finance Cost" },
    { value: "machinery cost", label: "Machinery Cost" },
  ];

  // ========== Sync editable rows with API data ==========
  const fetchNextGeneralNo = async () => {
    const data = await GetNextGeneralNo();
    if (data && data.gen_voucher_no) {
      setRows((prev) => {
        const updated = [...prev];
        // sirf first row ka voucher no set karo
        if (updated.length > 0) {
          updated[0] = {
            ...updated[0],
            gen_number: data.gen_voucher_no,
          };
        }
        return updated;
      });
    }
  };
  useEffect(() => {
    setRows(generalVouchers);
  }, [generalVouchers]);

  // ========== Open/Close Modals ==========
  // const handleOpen = () => setOpen(true);
  const handleOpen = () => {
    setRows([blankRow()]);
    setOpen(true);
  };
  const handleClose = () => {
    setRows([blankRow()]);
    setOpen(false);
  };

  console.log(GeneralToApprove);
  // ========== Helper: Blank row for add modal ==========
  function blankRow() {
    return {
      gen_voucher_no: "",
      gen_number: "",
      expense: "",
      imprest: "",
      bill_no: "",
      bill_date: "",
      project: "",
      division: "",
      division_name: "",
      status: "",
      payment_status: "",
      amount: "",
      attachment: "",
      narration: "",
      cost_type: "",
      created_at: localStorage.getItem("user_id"),
    };
  }

  // ========== Add new rows dynamically ==========
  const addRow = () => setRows([...rows, blankRow()]);
  const removeRow = (index) => setRows(rows.filter((_, i) => i !== index));

  // ========== Handle input change in add modal ==========
  const handleRowChange = (index, e) => {
    const { name, value, files } = e.target;
    const updated = [...rows];
    updated[index][name] = name === "attachment" ? files[0] : value;
    setRows(updated);
  };

  const handleApprove = async (voucher) => {
    const approvedById = Number(localStorage.getItem("user_id"));
    if (!approvedById) {
      toast.error("Approver ID not found.");
      return;
    }

    try {
      const updated = await ApproveGeneralVoucher(
        voucher.gen_voucher_no,
        approvedById,
        voucher.status,
        remarkInput
      ); // ✅ FIXED
      setGeneralVouchers((prev) =>
        prev.map((item) =>
          item.gen_voucher_no === voucher.gen_voucher_no ? updated : item
        )
      );

      toast.success(
        updated.status
          ? "General voucher approved successfully!"
          : "General voucher unapproved successfully!"
      );
    } catch (error) {
      toast.error("Failed to approve General Voucher.");
    }
  };
  const userId = Number(localStorage.getItem("user_id"));
  //handle submit
  const handleSubmit = async (e) => {
    // e.preventDefault();
    const timestamp = Date.now();

    const newData = rows.map((row, i) => {
      const { gen_voucher_no, ...rest } = row; // Exclude auto-field
      return {
        ...rest,
        created_by: userId,
        id: timestamp + i,
      };
    });

    const createdVouchers = [];

    for (const row of newData) {
      try {
        const created = await GeneralVoucherCreate(row); // Get full response
        createdVouchers.push(created);
      } catch (error) { }
    }

    const updated = [...generalVouchers, ...createdVouchers];
    setGeneralVouchers(updated); // ✅ Full data with project name & voucher no.
    toast.success("Voucher(s) added successfully");
    handleClose();
  };

  // ========== Open edit modal ==========
  const handleEditVoucher = (voucher, index) => {
    setEditFormData({ ...voucher });
    setEditIndex(index);
    setOpenEditModal(true);
  };

  // ========== Handle input change in edit modal ==========
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({
      ...prev,
      [name]: value, // store just the ID
    }));
  };
  const handleUpdateVoucher = async () => {
    const payload = { ...editFormData };
    delete payload.approved_by; // 🧹 Remove approved_by from payload
    // Remove unwanted fields
    delete payload.created_at;
    delete payload.updated_at;
    delete payload.gen_voucher_no;
    delete payload.gen_number;
    delete payload.project;
    delete payload.division;
    delete payload.cost_type;

    const formData = new FormData();

    // ✅ Correct key names for Django backend
    formData.append(
      "project_id",
      editFormData.project?.id || editFormData.project_id
    );
    formData.append("division", editFormData.division);
    formData.append("cost_type", editFormData.cost_type);
    // ✅ Attach file only if it's a File instance
    if (editFormData.attachment instanceof File) {
      formData.append("attachment", editFormData.attachment);
    }

    // ✅ Append the rest
    for (const key in payload) {
      if (key !== "attachment") {
        formData.append(key, payload[key]);
      }
    }

    try {
      const updatedVoucher = await GeneralVoucherUpdate(
        editFormData.gen_voucher_no,
        formData
      );
      const updatedRows = [...rows];
      updatedRows[editIndex] = updatedVoucher;

      setRows(updatedRows);
      setGeneralVouchers(updatedRows);
      toast.success("Voucher updated successfully");
      setOpenEditModal(false);
    } catch (err) {
      toast.error("Failed to update voucher");
    }
  };

  // ========== Delete voucher by ID ==========
  const handleDeleteVoucher = async (gen_voucher_no) => {
    const success = await GeneralVoucherDelete(gen_voucher_no); // gen_voucher_no is the PK

    if (success) {
      const updated = generalVouchers.filter(
        (voucher) => voucher.gen_voucher_no !== gen_voucher_no
      );
      setGeneralVouchers(updated); // ✅ This will re-render the table without refresh
      toast.success("Voucher deleted successfully");
    } else {
      toast.error("Failed to delete voucher");
    }
  };

  // ========== Print and View Placeholder ==========
  const handlePrintVoucher = (voucher) => {
    alert(`Printing Voucher: ${voucher.gen_voucher_no}`);
  };

  const handleViewVoucher = (voucher) => {
    alert(`Viewing Voucher: ${voucher.gen_voucher_no}`);
  };
  const userRole = localStorage.getItem("role"); // "admin" ya "staff"

  useEffect(() => {
    document.body.style.overflow = isMobile ? "auto" : "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobile]);
  function formatOnlyDate(dateTimeString) {
    if (!dateTimeString) return "N/A";

    // Take only the date part (before T)
    const datePart = dateTimeString.split("T")[0]; // "2025-12-02"

    const [year, month, day] = datePart.split("-");

    return `${day}-${month}-${year}`;
  }

  const getDateRangeDisplay = (rangeType) => {
    const now = new Date();
    const fmt = (d) =>
      `${d.getDate().toString().padStart(2, "0")}-${(d.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${d.getFullYear()}`;

    switch (rangeType) {
      case "today":
        return fmt(now);
      case "yesterday":
        const y = new Date(now);
        y.setDate(y.getDate() - 1);
        return fmt(y);
      case "this_week":
        const ws = new Date(now);
        ws.setDate(ws.getDate() - ws.getDay() + 1);
        return `${fmt(ws)} to ${fmt(now)}`;
      case "previous_week":
        const pwe = new Date(now);
        pwe.setDate(pwe.getDate() - pwe.getDay());
        const pws = new Date(pwe);
        pws.setDate(pws.getDate() - 6);
        return `${fmt(pws)} to ${fmt(pwe)}`;
      case "this_month":
        return `${fmt(new Date(now.getFullYear(), now.getMonth(), 1))} to ${fmt(
          now
        )}`;
      default:
        return "";
    }
  };

  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };
  return (
    <>
      <ToastContainer />

      <Box
        sx={{
          display: "flex",
          flexWrap: { xs: "wrap", md: "nowrap" }, // ✅ Mobile mein wrap, Desktop mein nowrap
          alignItems: "center",
          gap: 2,
          mt: -3,
          pt: 0,
          mb: 1,
          flexShrink: 0,
        }}
      >
        {/* Radio Buttons */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            width: { xs: "100%", md: "auto" }, // ✅ Mobile mein full width
            justifyContent: { xs: "space-around", md: "flex-start" }, // ✅ Mobile mein center
          }}
        >
          <label style={{ fontSize: "12px" }}>
            <input
              type="radio"
              name="status"
              value="Pending"
              checked={statusFilter === "Pending"}
              onChange={(e) => setStatusFilter(e.target.value)}
              style={{ marginRight: "5px", transform: "scale(0.6)" }}
            />
            Pending
          </label>

          <label style={{ fontSize: "12px" }}>
            <input
              type="radio"
              name="status"
              value="Approved"
              checked={statusFilter === "Approved"}
              onChange={(e) => setStatusFilter(e.target.value)}
              style={{ marginRight: "5px", transform: "scale(0.6)" }}
            />
            Approved
          </label>

          <label style={{ fontSize: "12px" }}>
            <input
              type="radio"
              name="status"
              value="Rejected"
              checked={statusFilter === "Rejected"}
              onChange={(e) => setStatusFilter(e.target.value)}
              style={{ marginRight: "5px", transform: "scale(0.6)" }}
            />
            Rejected
          </label>
        </Box>
        {/* ⭐ DATE RANGE FIELD */}
        <Box sx={{ width: { xs: "100%", sm: "50%", md: "20%" } }}>
          <TextField
            label="Date Range"
            value={
              dateRangeFilter === "custom" &&
                customDateRange.from &&
                customDateRange.to
                ? `${formatDateDisplay(
                  customDateRange.from
                )} to ${formatDateDisplay(customDateRange.to)}`
                : dateRangeFilter === "today"
                  ? "Today"
                  : dateRangeFilter === "yesterday"
                    ? "Yesterday"
                    : dateRangeFilter === "this_week"
                      ? "This Week"
                      : dateRangeFilter === "previous_week"
                        ? "Previous Week"
                        : dateRangeFilter === "this_month"
                          ? "This Month"
                          : "Select Date Range"
            }
            onClick={(e) => setDateMenuAnchor(e.currentTarget)}
            size="small"
            fullWidth
            InputProps={{
              readOnly: true,
              endAdornment: (
                <IconButton size="small">
                  <ArrowDropDownIcon />
                </IconButton>
              ),
            }}
            sx={{
              cursor: "pointer",
              "& .MuiInputBase-input": {
                fontSize: "0.8rem",
                padding: "4px 8px",
              },
              "& .MuiInputBase-root": { height: 30, borderRadius: 0 },
              "& .MuiInputLabel-root": { fontSize: "0.7rem" },
            }}
          />
        </Box>

        {/* Search Boxes */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flex: 1,
            width: "100%",
            flexDirection: { xs: "column", md: "row" }, // ✅ Mobile mein column, Desktop mein row
          }}
        >
          <TextField
            label="Search by Voucher No"
            variant="outlined"
            size="small"
            value={voucherSearch}
            onChange={(e) => setVoucherSearch(e.target.value)}
            sx={{
              flex: { xs: "none", md: 1 }, // ✅ Desktop mein flex: 1
              width: { xs: "100%", md: "auto" }, // ✅ Mobile mein full width
              "& .MuiInputBase-root": { height: 30, borderRadius: 0 },
              "& .MuiInputLabel-root": { fontSize: "0.7rem" },
            }}
            fullWidth
          />

          <TextField
            label="Search by Bill No"
            variant="outlined"
            size="small"
            value={billNoSearch}
            onChange={(e) => setBillNoSearch(e.target.value)}
            sx={{
              flex: { xs: "none", md: 1 },
              width: { xs: "100%", md: "auto" },
              "& .MuiInputBase-root": { height: 30, borderRadius: 0 },
              "& .MuiInputLabel-root": { fontSize: "0.7rem" },
            }}
            fullWidth
          />

          <TextField
            label="Search by Ledger"
            variant="outlined"
            size="small"
            value={ledgerSearch}
            onChange={(e) => setLedgerSearch(e.target.value)}
            sx={{
              flex: { xs: "none", md: 1 },
              width: { xs: "100%", md: "auto" },
              "& .MuiInputBase-root": { height: 30, borderRadius: 0 },
              "& .MuiInputLabel-root": { fontSize: "0.7rem" },
            }}
            fullWidth
          />
        </Box>
        {/* ⭐ HIDDEN DATE INPUT */}
        <input
          ref={dateInputRef}
          type="date"
          style={{
            position: "absolute",
            opacity: 0,
            pointerEvents: "none",
            width: 1,
            height: 1,
          }}
          value={
            selectingDate === "from" ? customDateRange.from : customDateRange.to
          }
          min={selectingDate === "to" ? customDateRange.from : undefined}
          onChange={(e) => {
            const val = e.target.value;
            if (selectingDate === "from") {
              setCustomDateRange((p) => ({ ...p, from: val }));
              setSelectingDate("to");
              setTimeout(() => dateInputRef.current?.showPicker(), 100);
            } else {
              setCustomDateRange((p) => ({ ...p, to: val }));
              setDateRangeFilter("custom");
              setSelectingDate(null);
              setDateMenuAnchor(null);
            }
          }}
        />

        {/* ⭐ DATE MENU - CONTRA FORMAT */}
        {/* ✅ Date Range Menu with Inline Custom Section */}
        <Menu
          anchorEl={dateMenuAnchor}
          open={Boolean(dateMenuAnchor)}
          onClose={() => {
            setDateMenuAnchor(null);
            setShowCustomDateInputs(false);
            setTempCustomDateRange({ from: "", to: "" });
          }}
          PaperProps={{ sx: { width: 340, maxHeight: 480 } }}
        >
          {[
            { key: "today", label: "Today" },
            { key: "yesterday", label: "Yesterday" },
            { key: "this_week", label: "This Week" },
            { key: "this_month", label: "This Month" },
          ].map((opt) => (
            <MenuItem
              key={opt.key}
              onClick={() => {
                setDateRangeFilter(opt.key);
                setCustomDateRange({ from: "", to: "" });
                setDateMenuAnchor(null);
                setShowCustomDateInputs(false);
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography variant="body2">{opt.label}</Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: "0.65rem" }}
                >
                  {getDateRangeDisplay(opt.key)}
                </Typography>
              </Box>
            </MenuItem>
          ))}

          <Divider />

          {/* Custom Range */}
          <MenuItem
            onClick={() => setShowCustomDateInputs((s) => !s)}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              bgcolor: showCustomDateInputs ? "#e3f2fd" : "inherit",
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: showCustomDateInputs ? 600 : 400 }}
            >
              Custom Date Range
            </Typography>
            {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
          </MenuItem>

          <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
            <Box
              sx={{
                px: 2,
                py: 2,
                bgcolor: "#f5f5f5",
                borderTop: "1px solid #e0e0e0",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ mb: 1, display: "block" }}
              >
                Select Date Range
              </Typography>

              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                  label="From Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.from}
                  onChange={(e) =>
                    setTempCustomDateRange((p) => ({
                      ...p,
                      from: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ max: tempCustomDateRange.to || undefined }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": { height: 40, fontSize: "0.75rem" },
                    "& .MuiInputLabel-root": { fontSize: "0.75rem" },
                  }}
                />
                <TextField
                  label="To Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.to}
                  onChange={(e) =>
                    setTempCustomDateRange((p) => ({
                      ...p,
                      to: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ min: tempCustomDateRange.from || undefined }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": { height: 40, fontSize: "0.75rem" },
                    "& .MuiInputLabel-root": { fontSize: "0.75rem" },
                  }}
                />
              </Box>

              {tempCustomDateRange.from && tempCustomDateRange.to && (
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    mb: 1.5,
                    p: 1,
                    bgcolor: "#e8f5e9",
                    borderRadius: 1,
                    textAlign: "center",
                    color: "#2e7d32",
                    fontWeight: 500,
                  }}
                >
                  📅 {formatDateDisplay(tempCustomDateRange.from)} to
                  {formatDateDisplay(tempCustomDateRange.to)}
                </Typography>
              )}

              <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCancelCustomDateRange}
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleApplyCustomDateRange}
                  disabled={
                    !tempCustomDateRange.from || !tempCustomDateRange.to
                  }
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Apply
                </Button>
              </Box>
            </Box>
          </Collapse>
        </Menu>
      </Box>

      <InfiniteScroll
        dataLength={generalVouchers.length}
        next={fetchMoreData}
        hasMore={hasMore}
        // scrollableTarget="scrollableDiv"
        loader={<h4>Loading...</h4>}
      >
        {/* 🔥 MOBILE VIEW - Expandable List */}
        {isMobile ? (
          <Box sx={{ bgcolor: "background.paper" }}>
            {generalVouchers.map((voucher, index) => (
              <Box key={index}>
                {/* Main Row - Always Visible */}
                <Box
                  onClick={() =>
                    setExpandedVoucher(
                      expandedVoucher === voucher.gen_voucher_no
                        ? null
                        : voucher.gen_voucher_no
                    )
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                    cursor: "pointer",
                    bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                    "&:active": {
                      bgcolor: "#e3f2fd",
                    },
                    borderLeft: `4px solid ${voucher.status === "Approved"
                        ? "#4caf50"
                        : voucher.status === "Rejected"
                          ? "#f44336"
                          : "#ff9800"
                      }`,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    {/* Voucher Number & Status */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 0.5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#666",
                          minWidth: 25,
                        }}
                      >
                        #{index + 1}
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.85rem",
                          flex: 1,
                        }}
                      >
                        {voucher.gen_number}
                      </Typography>
                    </Box>

                    {/* Ledger & Date */}
                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        color: "#666",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <span style={{ fontWeight: 500 }}>
                        {(
                          voucher.imprest_name ||
                          voucher.supplier_name ||
                          voucher.advanceworker_name ||
                          voucher.Transporter_name ||
                          ""
                        ).substring(0, 25)}
                      </span>
                      <span style={{ color: "#999" }}>•</span>
                      <span style={{ fontSize: "0.7rem" }}>
                        {formatOnlyDate(voucher.created_at)}
                      </span>
                    </Typography>
                  </Box>

                  {/* Expand Icon */}
                  <IconButton size="small" sx={{ ml: 1 }}>
                    {expandedVoucher === voucher.gen_voucher_no ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </IconButton>
                </Box>

                {/* Expanded Details */}
                <Collapse
                  in={expandedVoucher === voucher.gen_voucher_no}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      px: 1.5,
                      py: 1,
                      bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
                      borderLeft: `4px solid ${voucher.status === "Approved"
                          ? "#4caf50"
                          : voucher.status === "Rejected"
                            ? "#f44336"
                            : "#ff9800"
                        }`,
                    }}
                  >
                    {/* Detailed Info - 2 Column Grid */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 0.8,
                        mb: 1,
                      }}
                    >
                      {/* Ledger Name Full */}
                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          LEDGER NAME
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            color: "#333",
                          }}
                        >
                          {voucher.imprest_name ||
                            voucher.supplier_name ||
                            voucher.advanceworker_name ||
                            voucher.Transporter_name}
                        </Typography>
                      </Box>

                      {/* Bill No */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          BILL NO
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.bill_no || "-"}
                        </Typography>
                      </Box>

                      {/* Bill Date */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          BILL DATE
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {formatOnlyDate(voucher.bill_date)}
                        </Typography>
                      </Box>

                      {/* Total Amount */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          TOTAL AMT
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 600,
                            color: "#1976d2",
                          }}
                        >
                          ₹{" "}
                          {Number(voucher.grandtotal || 0).toLocaleString(
                            "en-IN"
                          )}
                        </Typography>
                      </Box>

                      {/* Paid Amount */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          PAID AMT
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 600,
                            color: "#4caf50",
                          }}
                        >
                          ₹{" "}
                          {Number(voucher.receipt_amount || 0).toLocaleString(
                            "en-IN"
                          )}
                        </Typography>
                      </Box>

                      {/* Balance Amount */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          BAL AMT
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 600,
                            color: "#f44336",
                          }}
                        >
                          ₹{" "}
                          {Number(voucher.balance_amount || 0).toLocaleString(
                            "en-IN"
                          )}
                        </Typography>
                      </Box>

                      {/* Division */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          DIVISION
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {voucher.division_name || "-"}
                        </Typography>
                      </Box>

                      {/* Project */}
                      {voucher.project_name && (
                        <Box sx={{ gridColumn: "1 / -1" }}>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            PROJECT
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {voucher.project_name}
                          </Typography>
                        </Box>
                      )}

                      {/* Payment Status */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                            mb: 0.3,
                          }}
                        >
                          PAYMENT STATUS
                        </Typography>
                        <Chip
                          label={
                            voucher.payment_status === "Paid"
                              ? "Paid"
                              : voucher.payment_status === "Unpaid"
                                ? "Unpaid"
                                : "Partial"
                          }
                          color={
                            voucher.payment_status === "Paid"
                              ? "success"
                              : voucher.payment_status === "Unpaid"
                                ? "error"
                                : "warning"
                          }
                          variant="outlined"
                          size="small"
                          sx={{
                            // fontSize: "0.2rem", // 👈 font chhota hoga
                            height: "10px",
                            transform: "scale(0.8)",
                            "& .MuiChip-label": {
                              padding: "0 6px",
                            },
                          }}
                        />
                      </Box>

                      {/* Created By */}
                      {voucher.created_by_name && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            CREATED BY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {voucher.created_by_name}
                          </Typography>
                        </Box>
                      )}

                      {/* Approved By */}
                      {voucher.approved_name && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            APPROVED BY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {voucher.approved_name}
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    {/* Narration */}
                    {voucher.narration && (
                      <Box sx={{ mb: 0.8 }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                            mb: 0.3,
                          }}
                        >
                          NARRATION
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#555",
                            fontStyle: "italic",
                            lineHeight: 1.3,
                          }}
                        >
                          {voucher.narration}
                        </Typography>
                      </Box>
                    )}

                    {/* Remarks */}
                    {voucher.remarks && (
                      <Box sx={{ mb: 0.8 }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                            mb: 0.3,
                          }}
                        >
                          REMARKS
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#555",
                            fontStyle: "italic",
                            lineHeight: 1.3,
                          }}
                        >
                          {voucher.remarks}
                        </Typography>
                      </Box>
                    )}

                    <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                    {/* Action Buttons */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      {/* Approve - Only Admin */}
                      {userRole != "Staff" && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            bgcolor:
                              voucher.status === "Approved"
                                ? "#e8f5e9"
                                : voucher.status === "Rejected"
                                  ? "#ffebee"
                                  : "#fff3e0",
                            px: 1,
                            py: 0.5,
                            borderRadius: "6px",
                            border: `1px solid ${voucher.status === "Approved"
                                ? "#4caf50"
                                : voucher.status === "Rejected"
                                  ? "#f44336"
                                  : "#ff9800"
                              }`,
                          }}
                        >
                          <Checkbox
                            checked={
                              voucher.status === "Approved" ||
                              voucher.status === "Rejected"
                            }
                            onChange={(e) => {
                              e.stopPropagation();
                              setApproveAnchorEl(e.currentTarget);
                              setGeneralToApprove(voucher);
                            }}
                            sx={{
                              padding: 0,
                              transform: "scale(0.75)",
                              color:
                                voucher.status === "Approved"
                                  ? "#4caf50"
                                  : voucher.status === "Rejected"
                                    ? "#f44336"
                                    : "#ff9800",
                              "&.Mui-checked": {
                                color:
                                  voucher.status === "Approved"
                                    ? "#4caf50"
                                    : "#f44336",
                              },
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              fontWeight: 600,
                              color:
                                voucher.status === "Approved"
                                  ? "#2e7d32"
                                  : voucher.status === "Rejected"
                                    ? "#c62828"
                                    : "#f57c00",
                            }}
                          >
                            {voucher.status === "Approved"
                              ? "Approved"
                              : voucher.status === "Rejected"
                                ? "Rejected"
                                : "Approve"}
                          </Typography>
                        </Box>
                      )}

                      {/* Action Buttons */}
                      <Box sx={{ display: "flex", gap: 0.6 }}>
                        {/* View Attachment */}
                        {typeof voucher.attachment === "string" && (
                          <a
                            href={`${voucher.attachment}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <IconButton
                              size="small"
                              sx={{
                                bgcolor: "#e1f5fe",
                                borderRadius: "6px",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  bgcolor: "#b3e5fc",
                                  transform: "scale(1.05)",
                                },
                                transition: "all 0.2s",
                              }}
                            >
                              <Visibility
                                sx={{ fontSize: "1rem", color: "#0288d1" }}
                              />
                            </IconButton>
                          </a>
                        )}

                        {voucher.attachment instanceof File && (
                          <a
                            href={URL.createObjectURL(voucher.attachment)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <IconButton
                              size="small"
                              sx={{
                                bgcolor: "#e1f5fe",
                                borderRadius: "6px",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  bgcolor: "#b3e5fc",
                                  transform: "scale(1.05)",
                                },
                                transition: "all 0.2s",
                              }}
                            >
                              <Visibility
                                sx={{ fontSize: "1rem", color: "#0288d1" }}
                              />
                            </IconButton>
                          </a>
                        )}

                        {/* Print */}
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            generatePdf(voucher);
                          }}
                          sx={{
                            bgcolor: "#fff3e0",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#ffe0b2",
                              transform: "scale(1.05)",
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Print sx={{ fontSize: "1rem", color: "#f57c00" }} />
                        </IconButton>
                      </Box>
                    </Box>
                  </Box>
                </Collapse>

                {/* Divider between items */}
                <Divider />
              </Box>
            ))}

            {/* Total Summary for Mobile */}
            <Box
              sx={{
                bgcolor: "#E3F2FD",
                p: 1.5,
                borderTop: "2px solid #1976d2",
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.75rem",
                  fontWeight: "bold",
                  mb: 1,
                  color: "#1976d2",
                }}
              >
                TOTALS
              </Typography>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  gap: 1,
                }}
              >
                <Box>
                  <Typography sx={{ fontSize: "0.6rem", color: "#666" }}>
                    Total Amt
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.75rem",
                      fontWeight: "bold",
                      color: "#1976d2",
                    }}
                  >
                    ₹{" "}
                    {generalVouchers
                      .reduce(
                        (sum, v) => sum + parseFloat(v.grandtotal || 0),
                        0
                      )
                      .toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                  </Typography>
                </Box>
                <Box>
                  <Typography sx={{ fontSize: "0.6rem", color: "#666" }}>
                    Paid Amt
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.75rem",
                      fontWeight: "bold",
                      color: "#4caf50",
                    }}
                  >
                    ₹{" "}
                    {generalVouchers
                      .reduce(
                        (sum, v) => sum + parseFloat(v.receipt_amount || 0),
                        0
                      )
                      .toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                  </Typography>
                </Box>
                <Box>
                  <Typography sx={{ fontSize: "0.6rem", color: "#666" }}>
                    Bal Amt
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.75rem",
                      fontWeight: "bold",
                      color: "#f44336",
                    }}
                  >
                    ₹{" "}
                    {generalVouchers
                      .reduce(
                        (sum, v) => sum + parseFloat(v.balance_amount || 0),
                        0
                      )
                      .toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        ) : (
          /* 💻 DESKTOP VIEW - Table (Same as before) */
          <TableContainer
            component={Paper}
            // id="scrollableDiv"
            sx={{
              maxHeight: "88vh",
              overflow: "auto",
            }}
          >
            <Table
              stickyHeader
              size="small"
              sx={{
                minWidth: 1600,
                "& td, & th": {
                  fontWeight: "400",
                  borderBottom: "1px solid #ccc",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  backgroundColor: "#f5f5f5",
                  padding: "0px 16px",
                },
              }}
            >
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "& th": {
                      fontWeight: "bold !important",
                      color: "#333",
                      borderBottom: "1px solid #999",
                      whiteSpace: "nowrap",
                      fontSize: "0.75rem",
                      pt: 0.5,
                      pb: 0.5,
                    },
                  }}
                >
                  {userRole != "Staff" && (
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                        backgroundColor: "#f5f5f5",
                        zIndex: 3,
                        paddingLeft: "30px",
                      }}
                    >
                      Approve
                    </TableCell>
                  )}
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: userRole != "Staff" ? 80 : 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                    }}
                  >
                    S.No.
                  </TableCell>

                  <TableCell>Voucher No</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Ladger Name</TableCell>
                  <TableCell>Bill No</TableCell>
                  <TableCell>Bill Date</TableCell>
                  <TableCell>Total Amt</TableCell>
                  <TableCell>Paid Amt</TableCell>
                  <TableCell>Bal Amt</TableCell>
                  <TableCell>Division</TableCell>
                  <TableCell>Project</TableCell>
                  <TableCell>Created By</TableCell>
                  <TableCell>Payment Status</TableCell>
                  <TableCell>Approved By</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Narration</TableCell>
                  <TableCell>Remarks</TableCell>
                  <TableCell
                    className="no-print"
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                      width: 200,
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {generalVouchers.map((voucher, index) => (
                  <TableRow
                    hover
                    key={index}
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#fff",
                      zIndex: 1,

                      backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                      "&:hover": {
                        backgroundColor: "#e3f2fd",
                        "& td": {
                          backgroundColor: "#e3f2fd !important",
                        },
                      },
                      "& td": {
                        fontSize: { xs: "0.65rem", sm: "0.75rem" },
                        whiteSpace: "nowrap",
                        padding: "0px",
                        color: (theme) =>
                          theme.palette.mode === "dark" ? "white" : "inherit",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "black" : "inherit",
                      },
                    }}
                  >
                    {userRole != "Staff" && (
                      <TableCell
                        sx={{
                          position: "sticky",
                          left: 0,
                          backgroundColor: "#fafafa",
                          zIndex: 3,
                        }}
                      >
                        <Checkbox
                          checked={
                            voucher.status === "Approved" ||
                            voucher.status === "Rejected"
                          }
                          onChange={(e) => {
                            setApproveAnchorEl(e.currentTarget);
                            setGeneralToApprove(voucher);
                          }}
                          sx={{
                            padding: 0,
                            paddingLeft: 1,
                            paddingRight: 1,
                            transform: "scale(0.6)",
                            color:
                              voucher.status === "Approved"
                                ? "green"
                                : voucher.status === "Rejected"
                                  ? "red"
                                  : "grey",
                            "&.Mui-checked": {
                              color:
                                voucher.status === "Approved" ? "green" : "red",
                            },
                          }}
                        />
                      </TableCell>
                    )}
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: userRole != "Staff" ? 80 : 0,
                        backgroundColor: "#fafafa",
                        zIndex: 3,
                      }}
                    >
                      {index + 1}
                    </TableCell>

                    <TableCell> {voucher.gen_number}</TableCell>
                    <TableCell align="center">
                      <Chip
                        label={
                          voucher.status === "Approved"
                            ? "Approved"
                            : voucher.status === "Rejected"
                              ? "Rejected"
                              : "Pending"
                        }
                        color={
                          voucher.status === "Approved"
                            ? "success"
                            : voucher.status === "Rejected"
                              ? "error"
                              : "warning"
                        }
                        variant="outlined"
                        size="small"
                        sx={{
                          // fontSize: "0.2rem", // 👈 font chhota hoga
                          height: "10px",
                          transform: "scale(0.8)",
                          "& .MuiChip-label": {
                            padding: "0 6px",
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      {voucher.imprest_name ||
                        voucher.supplier_name ||
                        voucher.advanceworker_name ||
                        voucher.Transporter_name}
                    </TableCell>
                    <TableCell>{voucher.bill_no}</TableCell>
                    <TableCell>{formatOnlyDate(voucher.bill_date)}</TableCell>
                    <TableCell>
                      {Number(voucher.grandtotal || 0).toLocaleString("en-IN")}
                    </TableCell>
                    <TableCell>
                      {Number(voucher.receipt_amount || 0).toLocaleString(
                        "en-IN"
                      )}
                    </TableCell>
                    <TableCell>
                      {Number(voucher.balance_amount || 0).toLocaleString(
                        "en-IN"
                      )}
                    </TableCell>
                    <TableCell>{voucher.division_name}</TableCell>
                    <TableCell>{voucher.project_name || ""}</TableCell>
                    <TableCell>{voucher.created_by_name}</TableCell>

                    <TableCell>
                      <Chip
                        label={
                          voucher.payment_status === "Paid"
                            ? "Paid"
                            : voucher.payment_status === "Unpaid"
                              ? "Unpaid"
                              : "Partial"
                        }
                        color={
                          voucher.payment_status === "Paid"
                            ? "success"
                            : voucher.payment_status === "Unpaid"
                              ? "error"
                              : "warning"
                        }
                        variant="outlined"
                        size="small"
                        sx={{
                          // fontSize: "0.2rem", // 👈 font chhota hoga
                          height: "10px",
                          transform: "scale(0.8)",
                          "& .MuiChip-label": {
                            padding: "0 6px",
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell>{voucher.approved_name}</TableCell>
                    <TableCell>{formatOnlyDate(voucher.created_at)}</TableCell>

                    <TableCell>
                      <Tooltip title={voucher.narration} arrow>
                        <span>{truncateText(voucher.narration, 20)}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Tooltip title={voucher.remarks || ""} arrow>
                        <span>{truncateText(voucher.remarks || "", 20)}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell
                      className="no-print"
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: "#fafafa",
                        zIndex: 2,
                      }}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          width: 36,
                          textAlign: "center",
                        }}
                      >
                        {typeof voucher.attachment === "string" ? (
                          <a
                            href={`${voucher.attachment}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <IconButton
                              color="info"
                              sx={{
                                padding: 0,
                                paddingLeft: 1,
                                paddingRight: 1,
                              }}
                              size="small"
                            >
                              <Visibility transform="scale(0.6)" />
                            </IconButton>
                          </a>
                        ) : voucher.attachment instanceof File ? (
                          <a
                            href={URL.createObjectURL(voucher.attachment)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <IconButton
                              color="info"
                              sx={{
                                padding: 0,
                                paddingLeft: 1,
                                paddingRight: 1,
                              }}
                              size="small"
                            >
                              <Visibility transform="scale(0.6)" />
                            </IconButton>
                          </a>
                        ) : (
                          <span
                            style={{ display: "inline-block", width: 24 }}
                          />
                        )}
                      </span>

                      <IconButton
                        sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                        color="warning"
                        size="small"
                        onClick={() => generatePdf(voucher)}
                      >
                        <Print transform="scale(0.6)" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}

                <TableRow
                  sx={{
                    "& td": {
                      backgroundColor: "#E3F2FD !important",
                      color: "#000 !important",
                      fontWeight: "bold !important",
                      pt: 0.6,
                      pb: 0.6,
                    },
                  }}
                >
                  <TableCell
                    colSpan={7}
                    align="right"
                    sx={{ fontWeight: "bold !important" }}
                  >
                    Totals:
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold !important" }}>
                    {generalVouchers
                      .reduce(
                        (sum, v) => sum + parseFloat(v.grandtotal || 0),
                        0
                      )
                      .toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold !important" }}>
                    {generalVouchers
                      .reduce(
                        (sum, v) => sum + parseFloat(v.receipt_amount || 0),
                        0
                      )
                      .toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold !important" }}>
                    {generalVouchers
                      .reduce(
                        (sum, v) => sum + parseFloat(v.balance_amount || 0),
                        0
                      )
                      .toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                  </TableCell>
                  <TableCell colSpan={8}></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </InfiniteScroll>

      {/* Popovers & Dialogs - Same as before */}
      {/* <Popover
        open={Boolean(approveAnchorEl)}
        anchorEl={approveAnchorEl}
        onClose={() => {
          setApproveAnchorEl(null);
          setGeneralToApprove(null);
          setRemarkInput("");
          setShowRemarkForGeneralId(null);
          setActionType(null);
        }}
        anchorReference="anchorPosition"
        anchorPosition={{
          top: window.innerHeight / 2,
          left: window.innerWidth / 2,
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
      >
        <Box sx={{ p: 2, minWidth: 1050 }}>
          <Typography variant="subtitle1" sx={{ textAlign: "center" }}>
            Journal Voucher
          </Typography>

          <Table
            size="small"
            sx={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "14px",
              backgroundColor: "#fff",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            <TableBody>
              <TableRow>
                <TableCell>
                  <b>Voucher No.</b>
                </TableCell>
                <TableCell> : {GeneralToApprove?.gen_number || "-"}</TableCell>

                <TableCell>
                  <b>Voucher Date</b>
                </TableCell>
                <TableCell>
                  {" "}
                  :{" "}
                  {GeneralToApprove?.created_at
                    ? dayjs(GeneralToApprove.created_at).format("DD/MM/YYYY")
                    : "-"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <b>Project</b>
                </TableCell>
                <TableCell> : {GeneralToApprove?.project_name || "-"}</TableCell>

                <TableCell>
                  <b>Payment Status </b>
                </TableCell>
                <TableCell>
                  {" "}
                  : {GeneralToApprove?.payment_status || "-"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <b>Bill No </b>
                </TableCell>
                <TableCell> : {GeneralToApprove?.bill_no || "-"}</TableCell>

                <TableCell>
                  <b>Bill Date </b>
                </TableCell>
                <TableCell>
                  {" "}
                  :{" "}
                   {GeneralToApprove?.bill_date
                    ? dayjs(GeneralToApprove.bill).format("DD/MM/YYYY")
                    : "-"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <b>Ledger Name </b>
                </TableCell>
                <TableCell>
                  {" "}
                  : {GeneralToApprove?.supplier_name || GeneralToApprove?.imprest_name || GeneralToApprove?.advanceworker_name || GeneralToApprove?.Transporter_name || GeneralToApprove?.party_name || GeneralToApprove?.expense_name || "-"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Divider sx={{ my: 2 }} />

          <Table aria-label="basic table">
            <thead>
              <tr>
                {[
                  "Expenses",
                  "Cost Type",
                  "Amount",
                  "GST",
                  "TDS",
                  "Total Amount",
                ].map((head) => (
                  <th
                    key={head}
                    style={{
                      background: "#f5f5f5",
                      fontWeight: 600,
                      textAlign: "center",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    {head}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {GeneralToApprove?.sub_vouchers?.map((item, index) => (
                <tr
                  key={item.id || index}
                  style={{
                    padding: "12px",
                    background: "#fff",
                    textAlign: "center",
                    borderBottom: "1px solid #e5e7eb",
                  }}
                >
                  <td>{item.expense_name || "-"}</td>
                  <td>{item.cost_type || "-"}</td>
                  <td>{item.amount || "-"}</td>
                  <td>{item.gst || "-"}</td>
                  <td>{item.tds || "-"}</td>
                  <td>{item.total_amount || "-"}</td>
                </tr>
              ))}

              <tr
                style={{
                  padding: "12px",
                  background: "#f4f6f8",
                  textAlign: "center",
                  borderBottom: "1px solid #e5e7eb",
                }}
              >
                <td colSpan={2} style={{ textAlign: "right" }}>
                  Total
                </td>
                <td>
                  {GeneralToApprove?.sub_vouchers
                    ?.reduce(
                      (sum, item) => sum + parseFloat(item.amount || 0),
                      0
                    )
                    .toFixed(2)}
                </td>
                <td>
                  {GeneralToApprove?.sub_vouchers
                    ?.reduce((sum, item) => sum + parseFloat(item.gst || 0), 0)
                    .toFixed(2)}
                </td>
                <td>
                  {GeneralToApprove?.sub_vouchers
                    ?.reduce((sum, item) => sum + parseFloat(item.tds || 0), 0)
                    .toFixed(2)}
                </td>
                <td>
                  {GeneralToApprove?.sub_vouchers
                    ?.reduce(
                      (sum, item) => sum + parseFloat(item.total_amount || 0),
                      0
                    )
                    .toFixed(2)}
                </td>
              </tr>
            </tbody>
          </Table>

          {showRemarkForGeneralId === GeneralToApprove?.gen_voucher_no ? (
            <>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Please enter remark before{" "}
                {actionType === "Approved" ? "approving" : "rejecting"}:
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={remarkInput}
                onChange={(e) => setRemarkInput(e.target.value)}
                placeholder="Enter remark"
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  color={actionType === "Approved" ? "success" : "error"}
                  size="small"
                  onClick={() => {
                    if (!remarkInput.trim()) {
                      toast.error("Remark is required!");
                      return;
                    }
                    handleApprove({
                      ...GeneralToApprove,
                      status: actionType,
                      remarks: remarkInput,
                    });
                    setApproveAnchorEl(null);
                    setGeneralToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForGeneralId(null);
                    setActionType(null);
                  }}
                >
                  Yes
                </Button>
                <Button
                  size="small"
                  onClick={() => {
                    setApproveAnchorEl(null);
                    setGeneralToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForGeneralId(null);
                    setActionType(null);
                  }}
                >
                  No
                </Button>
              </Box>
            </>
          ) : (
            <>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  mt: 2,
                }}
              >
                <Button
                  color="success"
                  size="small"
                  onClick={() => {
                    setShowRemarkForGeneralId(GeneralToApprove?.gen_voucher_no);
                    setActionType("Approved");
                  }}
                  disabled={GeneralToApprove?.status=="Approved"}
                >
                  Approve
                </Button>
                <Button
                  color="error"
                  size="small"
                  onClick={() => {
                    setShowRemarkForGeneralId(GeneralToApprove?.gen_voucher_no);
                    setActionType("Rejected");
                  }}
                  disabled={GeneralToApprove?.status=="Approved"}
                >
                  Reject
                </Button>

                <Button
                  color="#95A5A6"
                  size="small"
                  onClick={() => {
                    setApproveAnchorEl(null);
                    setGeneralToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForGeneralId(null);
                    setActionType(null);
                  }}
                > Close</Button>
              </Box>
            </>
          )}
        </Box>
      </Popover> */}
      <Popover
        open={Boolean(approveAnchorEl)}
        anchorEl={approveAnchorEl}
        onClose={() => {
          setApproveAnchorEl(null);
          setGeneralToApprove(null);
          setRemarkInput("");
          setShowRemarkForGeneralId(null);
          setActionType(null);
        }}
        anchorReference="anchorPosition"
        anchorPosition={{
          top: window.innerHeight / 2,
          left: window.innerWidth / 2,
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        PaperProps={{
          sx: {
            // Desktop - unchanged
            width: { md: "auto" },
            maxWidth: { md: 1050 },
            maxHeight: { md: "auto" },

            // Mobile - Fixed centering
            ...(window.innerWidth < 900 && {
              position: "fixed",
              top: "53%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "calc(100% - 32px)",
              maxWidth: "calc(100% - 32px)",
              maxHeight: "85vh",
              overflowY: "auto",
              margin: 0,
              borderRadius: "12px",
            }),
          },
        }}
        // Mobile override for perfect centering
        sx={{
          "& .MuiPopover-paper": {
            "@media (max-width: 899px)": {
              position: "fixed !important",
              top: "53% !important",
              left: "50% !important",
              transform: "translate(-50%, -50%) !important",
              margin: "0 !important",
            },
          },
        }}
      >
        <Box
          sx={{
            p: { xs: 1.5, sm: 2 },
            minWidth: { xs: "auto", md: 1050 },
            width: "100%",
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{
              textAlign: "center",
              fontSize: { xs: "16px", sm: "18px" },
              fontWeight: 600,
              mb: 2,
            }}
          >
            Journal Voucher
          </Typography>

          {/* Mobile: Card Layout | Desktop: Table Layout */}
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            {/* Mobile Card View */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
                backgroundColor: "#f9f9f9",
                borderRadius: 2,
                p: 2,
                mb: 2,
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Voucher No.
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    {GeneralToApprove?.gen_number || "-"}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Voucher Date
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    {GeneralToApprove?.created_at
                      ? dayjs(GeneralToApprove.created_at).format("DD/MM/YYYY")
                      : "-"}
                  </Typography>
                </Box>
              </Box>

              <Divider />

              <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Project
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    {GeneralToApprove?.project_name || "-"}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Payment Status
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    {GeneralToApprove?.payment_status || "-"}
                  </Typography>
                </Box>
              </Box>

              <Divider />

              <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Bill No
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    {GeneralToApprove?.bill_no || "-"}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Bill Date
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    {GeneralToApprove?.bill_date
                      ? dayjs(GeneralToApprove.bill_date).format("DD/MM/YYYY")
                      : "-"}
                  </Typography>
                </Box>
              </Box>

              <Divider />

              <Box>
                <Typography variant="caption" color="text.secondary">
                  Ledger Name
                </Typography>
                <Typography variant="body2" fontWeight={600}>
                  {GeneralToApprove?.supplier_name ||
                    GeneralToApprove?.imprest_name ||
                    GeneralToApprove?.advanceworker_name ||
                    GeneralToApprove?.Transporter_name ||
                    GeneralToApprove?.party_name ||
                    GeneralToApprove?.expense_name ||
                    "-"}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Desktop Table View */}
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <Table
              size="small"
              sx={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "14px",
                backgroundColor: "#fff",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <TableBody>
                <TableRow>
                  <TableCell><b>Voucher No.</b></TableCell>
                  <TableCell>: {GeneralToApprove?.gen_number || "-"}</TableCell>
                  <TableCell><b>Voucher Date</b></TableCell>
                  <TableCell>
                    :{" "}
                    {GeneralToApprove?.created_at
                      ? dayjs(GeneralToApprove.created_at).format("DD/MM/YYYY")
                      : "-"}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><b>Project</b></TableCell>
                  <TableCell>: {GeneralToApprove?.project_name || "-"}</TableCell>
                  <TableCell><b>Payment Status</b></TableCell>
                  <TableCell>: {GeneralToApprove?.payment_status || "-"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><b>Bill No</b></TableCell>
                  <TableCell>: {GeneralToApprove?.bill_no || "-"}</TableCell>
                  <TableCell><b>Bill Date</b></TableCell>
                  <TableCell>
                    :{" "}
                    {GeneralToApprove?.bill_date
                      ? dayjs(GeneralToApprove.bill_date).format("DD/MM/YYYY")
                      : "-"}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><b>Ledger Name</b></TableCell>
                  <TableCell colSpan={3}>
                    :{" "}
                    {GeneralToApprove?.supplier_name ||
                      GeneralToApprove?.imprest_name ||
                      GeneralToApprove?.advanceworker_name ||
                      GeneralToApprove?.Transporter_name ||
                      GeneralToApprove?.party_name ||
                      GeneralToApprove?.expense_name ||
                      "-"}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>

          <Divider sx={{ my: 2 }} />

          {/* Mobile: Cards for Sub Vouchers | Desktop: Table */}
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            {/* Mobile Cards for Sub Vouchers */}
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
              Expenses Details
            </Typography>
            {GeneralToApprove?.sub_vouchers?.map((item, index) => (
              <Box
                key={item.id || index}
                sx={{
                  backgroundColor: "#fff",
                  border: "1px solid #e5e7eb",
                  borderRadius: 2,
                  p: 2,
                  mb: 1.5,
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                  <Typography variant="body2" fontWeight={600}>
                    {item.expense_name || "-"}
                  </Typography>
                  <Typography variant="body2" color="primary" fontWeight={600}>
                    ₹{item.total_amount || "-"}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: 1,
                    fontSize: "12px",
                  }}
                >
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Cost Type
                    </Typography>
                    <Typography variant="body2">{item.cost_type || "-"}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Amount
                    </Typography>
                    <Typography variant="body2">₹{item.amount || "-"}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      GST
                    </Typography>
                    <Typography variant="body2">₹{item.gst || "-"}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      TDS
                    </Typography>
                    <Typography variant="body2">₹{item.tds || "-"}</Typography>
                  </Box>
                </Box>
              </Box>
            ))}

            {/* Mobile Total Card */}
            <Box
              sx={{
                backgroundColor: "#f4f6f8",
                borderRadius: 2,
                p: 2,
                mt: 2,
              }}
            >
              <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1 }}>
                Total Summary
              </Typography>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: 1,
                }}
              >
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Total Amount
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    ₹
                    {GeneralToApprove?.sub_vouchers
                      ?.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)
                      .toFixed(2)}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Total GST
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    ₹
                    {GeneralToApprove?.sub_vouchers
                      ?.reduce((sum, item) => sum + parseFloat(item.gst || 0), 0)
                      .toFixed(2)}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Total TDS
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    ₹
                    {GeneralToApprove?.sub_vouchers
                      ?.reduce((sum, item) => sum + parseFloat(item.tds || 0), 0)
                      .toFixed(2)}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Grand Total
                  </Typography>
                  <Typography variant="body1" fontWeight={700} color="primary">
                    ₹
                    {GeneralToApprove?.sub_vouchers
                      ?.reduce((sum, item) => sum + parseFloat(item.total_amount || 0), 0)
                      .toFixed(2)}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>

          {/* Desktop Table for Sub Vouchers */}
          <Box
            sx={{
              display: { xs: "none", md: "block" },
              overflowX: "auto",
            }}
          >
            <Table aria-label="basic table">
              <thead>
                <tr>
                  {["Expenses", "Cost Type", "Amount", "GST", "TDS", "Total Amount"].map(
                    (head) => (
                      <th
                        key={head}
                        style={{
                          background: "#f5f5f5",
                          fontWeight: 600,
                          textAlign: "center",
                          borderBottom: "1px solid #e5e7eb",
                          padding: "12px",
                        }}
                      >
                        {head}
                      </th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {GeneralToApprove?.sub_vouchers?.map((item, index) => (
                  <tr
                    key={item.id || index}
                    style={{
                      padding: "12px",
                      background: "#fff",
                      textAlign: "center",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <td style={{ padding: "12px" }}>{item.expense_name || "-"}</td>
                    <td style={{ padding: "12px" }}>{item.cost_type || "-"}</td>
                    <td style={{ padding: "12px" }}>{item.amount || "-"}</td>
                    <td style={{ padding: "12px" }}>{item.gst || "-"}</td>
                    <td style={{ padding: "12px" }}>{item.tds || "-"}</td>
                    <td style={{ padding: "12px" }}>{item.total_amount || "-"}</td>
                  </tr>
                ))}
                <tr
                  style={{
                    padding: "12px",
                    background: "#f4f6f8",
                    textAlign: "center",
                    borderBottom: "1px solid #e5e7eb",
                  }}
                >
                  <td colSpan={2} style={{ textAlign: "right", padding: "12px", fontWeight: 600 }}>
                    Total
                  </td>
                  <td style={{ padding: "12px", fontWeight: 600 }}>
                    {GeneralToApprove?.sub_vouchers
                      ?.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)
                      .toFixed(2)}
                  </td>
                  <td style={{ padding: "12px", fontWeight: 600 }}>
                    {GeneralToApprove?.sub_vouchers
                      ?.reduce((sum, item) => sum + parseFloat(item.gst || 0), 0)
                      .toFixed(2)}
                  </td>
                  <td style={{ padding: "12px", fontWeight: 600 }}>
                    {GeneralToApprove?.sub_vouchers
                      ?.reduce((sum, item) => sum + parseFloat(item.tds || 0), 0)
                      .toFixed(2)}
                  </td>
                  <td style={{ padding: "12px", fontWeight: 600 }}>
                    {GeneralToApprove?.sub_vouchers
                      ?.reduce((sum, item) => sum + parseFloat(item.total_amount || 0), 0)
                      .toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </Table>
          </Box>

          {/* Remark Section */}
          {showRemarkForGeneralId === GeneralToApprove?.gen_voucher_no ? (
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Please enter remark before{" "}
                {actionType === "Approved" ? "approving" : "rejecting"}:
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={remarkInput}
                onChange={(e) => setRemarkInput(e.target.value)}
                placeholder="Enter remark"
                multiline
                rows={2}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 1,
                  mt: 2,
                  flexWrap: "wrap",
                }}
              >
                <Button
                  variant="contained"
                  color={actionType === "Approved" ? "success" : "error"}
                  size="small"
                  sx={{ minWidth: { xs: "80px", sm: "100px" } }}
                  onClick={() => {
                    if (!remarkInput.trim()) {
                      toast.error("Remark is required!");
                      return;
                    }
                    handleApprove({
                      ...GeneralToApprove,
                      status: actionType,
                      remarks: remarkInput,
                    });
                    setApproveAnchorEl(null);
                    setGeneralToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForGeneralId(null);
                    setActionType(null);
                  }}
                >
                  Yes
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{ minWidth: { xs: "80px", sm: "100px" } }}
                  onClick={() => {
                    setApproveAnchorEl(null);
                    setGeneralToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForGeneralId(null);
                    setActionType(null);
                  }}
                >
                  No
                </Button>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-end" },
                gap: 1,
                mt: 2,
                flexWrap: "wrap",
              }}
            >
              <Button
                variant="contained"
                color="success"
                size="small"
                sx={{
                  minWidth: { xs: "90px", sm: "100px" },
                  fontSize: { xs: "12px", sm: "14px" },
                }}
                onClick={() => {
                  setShowRemarkForGeneralId(GeneralToApprove?.gen_voucher_no);
                  setActionType("Approved");
                }}
                disabled={GeneralToApprove?.status === "Approved"}
              >
                Approve
              </Button>
              <Button
                variant="contained"
                color="error"
                size="small"
                sx={{
                  minWidth: { xs: "90px", sm: "100px" },
                  fontSize: { xs: "12px", sm: "14px" },
                }}
                onClick={() => {
                  setShowRemarkForGeneralId(GeneralToApprove?.gen_voucher_no);
                  setActionType("Rejected");
                }}
                disabled={GeneralToApprove?.status === "Approved"}
              >
                Reject
              </Button>
              <Button
                variant="outlined"
                size="small"
                sx={{
                  minWidth: { xs: "90px", sm: "100px" },
                  fontSize: { xs: "12px", sm: "14px" },
                }}
                onClick={() => {
                  setApproveAnchorEl(null);
                  setGeneralToApprove(null);
                  setRemarkInput("");
                  setShowRemarkForGeneralId(null);
                  setActionType(null);
                }}
              >
                Close
              </Button>
            </Box>
          )}
        </Box>
      </Popover>

      {/* Edit Modal & Delete Popover - Same as before */}
      <Dialog open={openEditModal} onClose={() => setOpenEditModal(false)}>
        {/* ... existing edit modal code ... */}
      </Dialog>

      <Popover
        open={Boolean(deleteAnchorEl)}
        anchorEl={deleteAnchorEl}
        onClose={() => setDeleteAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, maxWidth: 200 }}>
          <Typography>Are you sure you want ?</Typography>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 2 }}
          >
            <Button size="small" onClick={() => setDeleteAnchorEl(null)}>
              No
            </Button>
            <Button
              size="small"
              color="error"
              onClick={() => {
                handleDeleteVoucher(selectedVoucherId);
                setDeleteAnchorEl(null);
              }}
            >
              Yes
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default GeneralVoucher;
// Use to close the popup
